
/**
 * 마지막 메시지 역할
 * @nullable
 */
export type ListConversations200ItemLastMessageRole = typeof ListConversations200ItemLastMessageRole[keyof typeof ListConversations200ItemLastMessageRole] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ListConversations200ItemLastMessageRole = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT',
  SYSTEM: 'SYSTEM',
} as const;
